// const dotenv = require('dotenv');
// dotenv.config();

type EnvNode = 'dev' | 'staging' | 'prod';

const getEnvValue = (
  prod: string | undefined,
  dev?: string | undefined,
  staging?: string | undefined,
): string => {
  const nodeEnv = (process.env.GATSBY_ENV_MODE as EnvNode) || 'prod';
  if (nodeEnv === 'dev') {
    return dev || '';
  } else if (nodeEnv === 'staging') {
    return staging || '';
  } else {
    return prod || '';
  }
};
const umbProjectAlias: string =
  getEnvValue(
    process.env.GATSBY_UMB_PROJECT_ALIAS || 'dev-trace-back-office',
    process.env.GATSBY_UMB_PROJECT_ALIAS_DEV,
    process.env.GATSBY_UMB_PROJECT_ALIAS_STAGING,
  ) || '';
const traceApiUrl: string =
  getEnvValue(
    process.env.GATSBY_TRACE_API_URL ||
      'https://us-central1-trace-plus-1338c.cloudfunctions.net/dev3/',
    process.env.GATSBY_TRACE_API_URL_DEV,
    process.env.GATSBY_TRACE_API_URL_STAGING,
  ) || '';

const envMode =
  umbProjectAlias.indexOf('dev') >= 0 ||
  umbProjectAlias.indexOf('stage') >= 0 ||
  traceApiUrl.indexOf('dev') >= 0
    ? 'dev'
    : process.env.GATSBY_ENV_MODE || 'prod';

// facebook connect
const disableFacebookConnect: boolean =
  getEnvValue(
    process.env.GATSBY_DISABLE_FACEBOOK_CONNECT,
    process.env.GATSBY_DISABLE_FACEBOOK_CONNECT_DEV,
    process.env.GATSBY_DISABLE_FACEBOOK_CONNECT_STAGING,
  ) === 'true';

const apiConfig = {
  withFacebookConnect: !disableFacebookConnect,
  withLearn: process.env.GATSBY_WITH_LEARN === 'true',
  envMode: envMode,
  graphqlUrl: process.env.GATSBY_GRAPHQL_URL || '',
  restUrl: process.env.GATSBY_REST_URL || '',
  contentManagmentUrl: process.env.GATSBY_CM_REST_URL || '',
  umbApiKey:
    getEnvValue(
      process.env.GATSBY_UMB_API_KEY || '3OXU7JMyMnmIbBwBBlU9',
      process.env.GATSBY_UMB_API_KEY_DEV,
      process.env.GATSBY_UMB_API_KEY_STAGING,
    ) || '',
  umbProjectAlias: umbProjectAlias,
  traceApiUrl: traceApiUrl,
  traceConsentApiUrl:
    process.env.GATSBY_TRACE_CONSENT_API_URL ||
    'https://vmovphiodxjcnuahhrww.supabase.co/functions/v1/consent',
  traceConsentAuthorization:
    process.env.GATSBY_TRACE_CONSENT_AUTHORIZATION ||
    'a3f5c92e1b8d4f6a9c0e2d7b3a1f8e6d9c4b7a2f5e8d1c6b9a4f3e7d2c5b8a1f',
  traceConsentApiKey:
    process.env.GATSBY_TRACE_CONSENT_API_KEY ||
    'sb_publishable_SkVxitwbk0H9Z3oxYDGHXQ_dnLtS0UX',
  livestreamClientId: process.env.GATSBY_LIVESTREAM_CLIENT_ID || '',
  umbBoUrl:
    getEnvValue(
      process.env.GATSBY_UMB_BO_URL ||
        'https://dev-trace-back-office.euwest01.umbraco.io',
      process.env.GATSBY_UMB_BO_URL_DEV,
      process.env.GATSBY_UMB_BO_URL_STAGING,
    ) || '',
  didomiApiKey: process.env.GATSBY_DIDOMI_API_KEY || '',
  didomiNoticeId: process.env.GATSBY_DIDOMI_NOTICE_ID || '',
  appsFlyerDevKey: process.env.GATSBY_APPS_FLYER_DEV_KEY || '',
  appsFlyerWebDevKey: process.env.GATSBY_APPS_FLYER_WEB_DEV_KEY || '',
  appsFlyerSmartBannerKey: process.env.GATSBY_APPS_FLYER_SMART_BANNER_KEY || '',
  appsFlyerSmartBannerEnabled:
    process.env.GATSBY_APPS_FLYER_SMART_BANNER_ENABLED === 'true',
  appiOSId: process.env.GATSBY_APP_IOS_ID || '',
  amplitude: {
    // Trace+ Prod project (reference). The active key is normally supplied by
    // the GATSBY_AMPLITUDE_API_KEY build env var; this hardcoded value is the
    // fallback and must point at Trace+ Prod, NOT the "Production Web" project.
    // NOTE: the production deploy env var GATSBY_AMPLITUDE_API_KEY must also be
    // set to this key — the fallback alone does not override an env override.
    apiKey:
      getEnvValue(
        process.env.GATSBY_AMPLITUDE_API_KEY ||
          'f7dc8a758d5dd09e7fc23ab191eb700c',
        process.env.GATSBY_AMPLITUDE_API_KEY_DEV,
        process.env.GATSBY_AMPLITUDE_API_KEY_STAGING,
      ) || '',
    debugLevel:
      envMode !== 'prod'
        ? 3
        : process.env.GATSBY_AMPLITUDE_DEBUG_LEVEL
          ? parseInt(process.env.GATSBY_AMPLITUDE_DEBUG_LEVEL, 10)
          : 0,
  },
  freemiumProductId:
    process.env.GATSBY_FREEMIUM_PRODUCT_ID || 'trace.subscription.free',
  iosSharedSecret: process.env.GATSBY_IOS_SHARED_SECRET || '',
  techCookiePurpId: process.env.GATSBY_TECHNICAL_COOKIE || '',
  geolocPurpId: process.env.GATSBY_GEOLOCALISATION || '',
  appsFlyerPurpId: process.env.GATSBY_APPS_FLYER || '',
  amplitudePurpId: process.env.GATSBY_AMPLITUDE_PURPOSE_ID || '',
  mcContentPurpId: process.env.GATSBY_MC_CONTENT || '',
  mcStandardAdsPurpId: process.env.GATSBY_MC_STANDARD_ADS || '',
  mcPersonalisedPurpId: process.env.GATSBY_MC_PERSONALISED_ADS || '',
  commingSoonEnabled: process.env.GATSBY_COMMIN_SOON_ENABLED || '',
  recaptchSiteKey: process.env.GATSBY_RECAPTCHA_SITE_KEY || '',
  amplitudeVendorId: process.env.GATSBY_AMPLITUDE_VENDOR_ID,
  brazeId: process.env.GATSBY_BRAZE_DIDOMI_ID || '',
  stripe: {
    paymentLink: {
      yearly:
        getEnvValue(
          process.env.GATSBY_STRIPE_PAYMENT_LINK_YEARLY || '',
          process.env.GATSBY_STRIPE_PAYMENT_LINK_YEARLY_DEV,
          process.env.GATSBY_STRIPE_PAYMENT_LINK_YEARLY_DEV,
        ) || '',
      monthly:
        getEnvValue(
          process.env.GATSBY_STRIPE_PAYMENT_LINK_MONTHLY || '',
          process.env.GATSBY_STRIPE_PAYMENT_LINK_MONTHLY_DEV,
          process.env.GATSBY_STRIPE_PAYMENT_LINK_MONTHLY_DEV,
        ) || '',
    },
  },
  brazeApiKey:
    getEnvValue(
      process.env.GATSBY_BRAZE_API_KEY || '',
      process.env.GATSBY_BRAZE_API_KEY_DEV,
      process.env.GATSBY_BRAZE_API_KEY_DEV,
    ) || '',
  brazeBaseUrl:
    getEnvValue(
      process.env.GATSBY_BRAZE_BASE_URL || 'sdk.iad-01.braze.com',
      process.env.GATSBY_BRAZE_BASE_URL_DEV,
      process.env.GATSBY_BRAZE_BASE_URL_DEV,
    ) || '',
  // ---- Tracking pipeline (Amplitude / Braze / AppsFlyer / Backend relay)
  tracking: {
    /** Backend relay endpoint base URL. Falls back to traceApiUrl. */
    relayBaseUrl:
      getEnvValue(
        process.env.GATSBY_TRACKING_RELAY_URL || '',
        process.env.GATSBY_TRACKING_RELAY_URL_DEV,
        process.env.GATSBY_TRACKING_RELAY_URL_STAGING,
      ) || '',
    /** Bearer key for POST /api/tracking/events (issued by backend team). */
    relayApiKey:
      getEnvValue(
        process.env.GATSBY_TRACKING_RELAY_API_KEY || '',
        process.env.GATSBY_TRACKING_RELAY_API_KEY_DEV,
        process.env.GATSBY_TRACKING_RELAY_API_KEY_STAGING,
      ) || '',
    /** Optional: enable AppsFlyer Web PBA. Off by default until verified. */
    appsFlyerWebEnabled:
      (process.env.GATSBY_APPSFLYER_WEB_ENABLED || 'false') === 'true',
    /** Optional: enable the console adapter (logs every event to devtools). */
    consoleAdapterEnabled:
      envMode !== 'prod' ||
      (process.env.GATSBY_TRACKING_CONSOLE || '') === 'true',
  },
};

export default apiConfig;
